import { useMemo } from 'react';
import {
  VerifyUserHasRbacPermissions,
  validateUserHasRbacPermissions,
} from '../utils/validateUserHasRbacPermissions';

export const useValidateUserHasRbacPermissions = (config: VerifyUserHasRbacPermissions) =>
  useMemo((): boolean => validateUserHasRbacPermissions(config), [config]);
